import Component from '@glimmer/component';
import { PrismDataBar } from '@mylighthouse/prism-ember';
import type { BarData } from '@mylighthouse/prism-ember/types/components/prism/data-bar';
import {
  COLOR_TRAFFIC_LIGHT_NEGATIVE,
  COLOR_TRAFFIC_LIGHT_POSITIVE,
  getCssVariableValue,
} from 'frontend-utils/utils/css-variable';
import getProgressBarPercentage from 'lumen/utils/revenue-insight/get-progress-bar-percentage';

interface HotelAndMarketRevenueInsightTooltipsTooltipBarGraphWithChangeSignature {
  Args: {
    maxValue?: number;
    value?: number;
  };
}

export default class HotelAndMarketRevenueInsightTooltipsTooltipBarGraphWithChange extends Component<HotelAndMarketRevenueInsightTooltipsTooltipBarGraphWithChangeSignature> {
  negativeColor = getCssVariableValue(COLOR_TRAFFIC_LIGHT_NEGATIVE);
  positiveColor = getCssVariableValue(COLOR_TRAFFIC_LIGHT_POSITIVE);

  // Absolute value so that the progress bar also shows negative values
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get absoluteValue() {
    return this.args.value ? Math.abs(this.args.value) : undefined;
  }

  // Background color is positive/negative depending on the value > 0 or not.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get backgroundColor() {
    if (!this.args.value) {
      return '';
    }

    if (this.args.value >= 0) {
      return this.positiveColor;
    }

    return this.negativeColor;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get barPercentage() {
    return getProgressBarPercentage(this.absoluteValue, this.args.maxValue);
  }

  get progressBarData(): BarData[] {
    return [
      {
        widthPercentage: this.barPercentage,
        backgroundColor: this.backgroundColor,
      },
    ] as BarData[];
  }

  <template><PrismDataBar @data={{this.progressBarData}} /></template>
}
